var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "批量修改虚拟销量",
        width: "60%",
        "before-close": _vm.closeDialog,
        "custom-class": "scan-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-row",
        [
          _vm._v(" 批量填入： "),
          _c("el-input-number", {
            attrs: { min: 0 },
            model: {
              value: _vm.oneSet,
              callback: function ($$v) {
                _vm.oneSet = $$v
              },
              expression: "oneSet",
            },
          }),
          _c("el-button", { staticClass: "ml8", on: { click: _vm.onOneSet } }, [
            _vm._v("一键设置"),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticStyle: { width: "100%", "margin-top": "24px" },
          attrs: { data: _vm.list, height: "50vh" },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "90" },
          }),
          _c("el-table-column", {
            attrs: { label: "商品名称", prop: "storeName", "min-width": "300" },
          }),
          _c("el-table-column", {
            attrs: { label: "虚拟销量", width: "180", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      model: {
                        value: scope.row.virtualSales,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "virtualSales", $$v)
                        },
                        expression: "scope.row.virtualSales",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "70", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.onRemove(scope.$index)
                          },
                        },
                      },
                      [_vm._v("移除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mt20 mb20", attrs: { type: "flex", justify: "end" } },
        [
          _c("el-button", { on: { click: _vm.closeDialog } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }